/**
 * Web stub — biometric auth is native-only. Keeps `expo-local-authentication` off the web
 * bundle while exposing the same surface; reports "no biometrics / can't authenticate".
 */
export type BiometricKind = 'face' | 'fingerprint' | 'iris' | null;

export const getBiometricKind = async (): Promise<BiometricKind> => null;

export const authenticateBiometric = async (): Promise<boolean> => false;
